import { createStyles } from 'antd-style';

import { ThemeSpaces } from '../../theme';
import { inputText } from '../../styles/mixins';

const SIZE_PX = {
  sm: 32,
  md: 40,
  lg: 44,
};

export const useLetterInputStyles = createStyles(({ token }, size) => ({
  inputText: {
    ...inputText(token),
  },
  letterInput: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: ThemeSpaces.SPACE_NORM,

    '.ant-input': {
      textAlign: 'center',
      width: SIZE_PX[size] || SIZE_PX.md,
      height: SIZE_PX[size] || SIZE_PX.md,
    },
  },
}));
